import { t as uiText } from '../i18n';
// src/pages/AdminOpenCreateRedirect.tsx
// 外部リンク「企業アカウントを作成」用: 所属があればそのコンテキストの settings へ ?create=1 で遷移
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../lib/firebase';
import {
  adminOrgPath,
  fetchUserCompanyIds,
  pickCompanyIdFromUserList,
  readLastAdminCompanyId,
  ADMIN_NO_COMPANY_PLACEHOLDER,
} from '../utils/adminRoutes';

const AdminOpenCreateRedirect: React.FC = () => {
  const [user, authLoading] = useAuthState(auth as any);
  const [target, setTarget] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (authLoading) return;
    if (!user?.uid) {
      setTarget('/sys/login');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const ids = await fetchUserCompanyIds(user.uid);
        const pick = pickCompanyIdFromUserList(ids, readLastAdminCompanyId());
        const companyId = pick ?? ADMIN_NO_COMPANY_PLACEHOLDER;
        const path = `${adminOrgPath(companyId, 'settings')}?create=1`;
        if (!cancelled) setTarget(path);
      } catch (e) {
        console.warn('[AdminOpenCreateRedirect] failed', e);
        if (!cancelled) {
          setTarget(`${adminOrgPath(ADMIN_NO_COMPANY_PLACEHOLDER, 'settings')}?create=1`);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [user?.uid, authLoading]);

  if (!target) {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui', color: '#666', fontSize: 14 }}>
        {uiText("Loading now...")}
      </div>
    );
  }

  if (target === '/sys/login') {
    return <Navigate to="/sys/login" replace />;
  }

  return <Navigate to={target} replace />;
};

export default AdminOpenCreateRedirect;
